import React from 'react'
import { Spinner} from 'evergreen-ui';

function CircleProgressLoader() {
  return (
    <div>
        <Spinner />
    </div>
  )
}

export default CircleProgressLoader